<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-card>
      <v-card-text class="pa-5">
        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="items"
              :options.sync="options"
              :server-items-length="total"
              class="contact-listing-app"
              >
              <template v-slot:top>
                <v-toolbar flat class="mb-8">
                  <v-row>
                    <v-col cols="12" lg="6">
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Поиск..."
                        filled
                        background-color="transparent"
                        hide-details
                        name="title"
                        >
                        <v-btn v-if="search" class="reset-button"
                               slot="append"
                               icon
                               @click="search=null"
                               color="red"
                               >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-text-field>
                    </v-col>
                    <v-col>
                      <v-switch v-model="only_trashed" label="Показать удаленные" name="only_trashed" value="1" style="margin-top: 16px;"/>
                    </v-col>
                  </v-row>
                  <v-spacer/>
                  <v-btn color="primary" to="/reviews/types/create" dark class="mb-2 text-capitalize">
                    <v-icon class="mr-2">mdi-message-cog</v-icon>
                    Добавить новый тип
                  </v-btn>
                </v-toolbar>
              </template>
              <template v-slot:item.id="{ item }">
                <v-chip pill>{{ item.id }}</v-chip>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon
                  v-if="item.deleted_at"
                  color="green"
                  small
                  @click="restoreItem(item)"
                >
                  mdi-undo
                </v-icon>
                <template v-else>
                  <v-btn
                    :href="editItem(item)"
                    icon
                  >
                    <v-icon color="primary" small>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                  <v-icon
                    small
                    color="red"
                    @click="deleteItem(item)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {ReviewsType} from "../../../../models/reviewsType";
import axiosInstance from "../../../../axiosInstance";

export default {
  name: 'Index',
  data: () => ({
    loading: true,
    total: 0,
    options: {
      sortBy: ['id'],
      sortDesc: [true],
    },
    search: '',
    only_trashed: false,
    headers: [
      {text: 'Id', value: 'id'},
      {text: 'Название', value: 'title'},
      {text: 'Дата создания', value: 'created_at'},
      {text: 'Дата обновления', value: 'updated_at'},
      {text: '', value: 'actions'},
    ],
    items: [],
    page: {
      title: "Типы отзывов"
    },
    breadcrumbs: [
      {
        text: "Админ панель",
        disabled: false,
        to: '/'
      },
      {
        text: "Типы отзывов",
        disabled: true,
        to: '/reviews/types'
      },
    ]
  }),
  created() {
    this.get();
  },
  methods: {
    editItem(item) {
      return this.$router.resolve({name: 'review-types-edit', params: {id: item.id}}).href
    },
    async deleteItem(item) {
      this.$confirm('Вы уверены?', 'Удаление').then(async () => {
        await ReviewsType.$query().destroy(item.id, 0);
        await this.get();
      });
    },
    async restoreItem(item) {
      await ReviewsType.$query().restore(item.id);
      await this.get();
    },
    async get() {
      this.loading = true;
      const {sortBy, sortDesc, page, itemsPerPage} = this.options;

      const data = {};
      this.search ? data.search = {value: this.search} : null;
      sortBy && sortBy[0] ? data.sort = [{field: sortBy[0], direction: sortDesc[0] ? 'desc' : 'asc'}] : null;
      const onlyTrashed = this.only_trashed ? `&only_trashed=1` : '';

      await axiosInstance.post(`/module/review-types/search?limit=${itemsPerPage}&page=${page}${onlyTrashed}`, data)
        .then((response) => {
          this.items = response.data.data;
          this.total = response.data.meta.total;
        });

      this.loading = false;
    },
  },
  watch: {
    search: {
      handler() {
        this.get();
      }
    },
    options: {
      handler() {
        this.get()
      },
      deep: true,
    },
    only_trashed: {
      handler() {
        this.get()
      },
      deep: true,
    },
  },
};
</script>
